module.exports = __webpack_public_path__ + "img/dateSingedEle.d16afdbf.svg";